import { ViewMode } from '@rikstv/play-player/src/player.types';

export const isTheatreMode = (viewMode: ViewMode): boolean => viewMode === 'theatre';
